/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {CreativeSetCopyModalComponent} from './creative-set-copy-modal.component';
import {AdminResourceCopyConfig} from '../common/controller/admin-resource-copy-config';
import {AdminResourceRouteContext, readAdminResourceRouteContext} from '../common/controller/admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-creative-set-context-route-page',
  template: `
    <adn-admin-resource-context-actions
      *ngIf="context"
      [model]="context.model"
      [modelComms]="context.modelComms"
      [isNew]="context.isNew"
      [readOnly]="context.readOnly"
      [copyConfig]="copyConfig">
    </adn-admin-resource-context-actions>
  `
})
export class CreativeSetContextRoutePageComponent implements OnInit {
  context: AdminResourceRouteContext;

  readonly copyConfig: AdminResourceCopyConfig = {
    modalComponent: CreativeSetCopyModalComponent,
    stateUrl: 'app.adv.creative-sets.creative-set',
    lcase: 'creative set',
    ucase: 'Creative Set'
  };

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    this.context = readAdminResourceRouteContext(this.uiRouter);
  }
}
